<div
  class="htc-lexical-table-wrapper"
  [ngClass]="{ 'htc-lexical-default-bg': usesDefaultBG }">
  <div
    id="htc-lexical-table-container"
    class="htc-lexical-table-container"
    data-testid="htc-table-container"
    #lexicalComposer
    [attr.contenteditable]="config.editable"
    role="presentation"></div>
</div>
